<template>
  <v-container>
    <v-flex xs12 sm10 offset-sm1>
      <v-card>
        <!-- <v-card-title primary-title>
        </v-card-title> -->

         <v-card-text class="subheading font-weight-regular">
            <div>{{ predict_aat_text }} </div>
        </v-card-text>
        <v-card-text class="subheading font-weight-regular">
            <div>{{ graph_text }} </div>
        </v-card-text>

        <v-card-text class="subheading font-weight-regular">
            <h4 class="headline mb-0">Reference</h4>
            <div>{{ reference_text }} </div>
        </v-card-text>
        <v-card-text>
          <p class="subheading font-weight-regular">
            <a href="https://www.tandfonline.com/doi/full/10.1080/15412555.2017.1401600" target="_blank">Link to the article</a>
          </p>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      predict_aat_text: "In a recent publication (1) we described an algorithm that allows adjustment of Alpha–1 Antitrypsin (AAT) levels to the levels of C–reactive protein (CRP) and AAT genotype. \
      Both proteins belong to the group of acute phase reactants, whose blood levels rise in response to an acute phase stimulant (i.e. inflammation, infection, injury). \
      CRP is commonly measured as an indicator of an acute phase. The blood levels of AAT and CRP are closely correlated. \
      An additional factor that influences the level of AAT is the AAT (PI*) genotype. \
      Several genotypes are associated with levels that also differ in their acute phase response. ",
      graph_text: "The graphic shows the levels of AAT of common genotypes (MM, MZ, MS) at baseline (solid line) and during an acute phase (dotted line) when CRP is elevated ( >5 mg/L). \
        The online calculator given here is based on the algorithm for the adjustment of AAT, according to CRP levels, and AAT genotype. \
        To use it, enter the values of AAT, CRP and AAT genotype in the indicated fields and press “calculate.” \
        The result will show the predicted level of AAT at baseline as it would be in the absence of an acute phase.",
      reference_text: "Sanders, CL, Ponte, A, Kueppers, F The Effects of Inflammation on Alpha–1 Antitrypsin Levels in a National Screening Cohort. \
      COPD: Journal of Chronic Obstructive Pulmonary Disease. 2018; 15 (1) 10-16."
    }
  }
}
</script>